import { startOfWeek as e } from "./startOfWeek.js";
function a(t) {
  return e(t, { weekStartsOn: 1 });
}
export {
  a as default,
  a as startOfISOWeek
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/startOfISOWeek.js
// module id = 249
// module chunks = 67